module.exports = __webpack_public_path__ + "static/media/settings.ae63df05.png";